export const putHolidaysInitState = {
	holidays: null,
	error: null,
	errorShow: false,
	loading: false,
};
